const req1 = require.context('../assets/images/accessPlatform/swiperImg/firstLine', false, /\.png$/)
const req2 = require.context('../assets/images/accessPlatform/swiperImg/secondLine', false, /\.png$/)
const req3 = require.context('../assets/images/accessPlatform/swiperImg/thirdLine', false, /\.png$/)

const list = [req1, req2, req3].map(each => {
  return each.keys().map(each)
})

export default list



// WEBPACK FOOTER //
// ./src/utils/getImages.js